export default __webpack_public_path__ + "assets/images/cfc2b7a62187622acfb6397f972a26ef.svg";